import { Space } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { Input } from 'components/atoms/input';

const Container = styled.div`
  width: 400px;
`;

export const DemoInputPage: FC = () => {
  return (
    <Container>
      <Space direction="vertical">
        <Input />
        <Input disabled defaultValue="foo bar" />
        <Input autoComplete="false" suffix=".rocketlane.com" />
        <Input
          disabled
          defaultValue="acme"
          autoComplete="false"
          suffix=".rocketlane.com"
        />
      </Space>
    </Container>
  );
};
